/**
 * Large UPS list column width tokens — equal flex per rack table design (#1154).
 */

import {
  repeatableColumnCellStyle,
  repeatableColumnHorizontalPadding,
  repeatableCompactColumnLayoutForTests,
  repeatableDesktopColumnLayoutForTests,
} from '../repeatableSections/repeatableTableColumnLayout';

import type {
  LargeUpsTableColumnKey,
  LargeUpsTableLayout,
} from './largeUpsListUtils';

export function largeUpsColumnHorizontalPadding(
  column: LargeUpsTableColumnKey,
  layoutMode: LargeUpsTableLayout,
): number {
  return repeatableColumnHorizontalPadding(column, layoutMode);
}

export function largeUpsColumnCellStyle(
  column: LargeUpsTableColumnKey,
  layoutMode: LargeUpsTableLayout,
): Record<string, unknown> {
  const paddingHorizontal = largeUpsColumnHorizontalPadding(column, layoutMode);
  // Desktop: keep STATUS compact. Compact/mobile: equal flex with other columns.
  if (column === 'STATUS' && layoutMode !== 'compact') {
    return {
      flex: 0,
      flexGrow: 0,
      flexShrink: 0,
      width: 84,
      minWidth: 84,
      paddingHorizontal,
    };
  }
  return repeatableColumnCellStyle(column, layoutMode);
}

/** @internal — unit tests assert equal flex layout. */
export const desktopColumnLayoutForTests =
  repeatableDesktopColumnLayoutForTests;

/** @internal — unit tests assert equal flex layout. */
export const compactColumnLayoutForTests =
  repeatableCompactColumnLayoutForTests;
